import styles from './Admin.module.css';

export function AdminSystemHealth() {
  const isDev = import.meta.env.DEV;

  return (
    <div>
      <header className={styles.pageHeader}>
        <h1>System Health</h1>
        <p style={{ color: 'var(--text-3)' }}>Real-time infrastructure status.</p>
      </header>

      <div className={styles.statsGrid}>
        <div className={styles.statCard}>
          <h3>Environment</h3>
          <div className={styles.value} style={{ fontSize: '1.5rem', color: isDev ? '#f59e0b' : '#10b981' }}>
            {isDev ? 'Development' : 'Production'}
          </div>
        </div>

        <div className={styles.statCard}>
          <h3>Firebase Connection</h3>
          <div className={styles.value} style={{ fontSize: '1.5rem', color: '#10b981' }}>
            Online
          </div>
        </div>

        <div className={styles.statCard}>
          <h3>NVIDIA AI API</h3>
          <div className={styles.value} style={{ fontSize: '1.5rem', color: '#10b981' }}>
            Operational
          </div>
        </div>

        <div className={styles.statCard}>
          <h3>Last Deployment</h3>
          <div className={styles.value} style={{ fontSize: '1.5rem' }}>
            {new Date().toLocaleDateString()}
          </div>
        </div>
      </div>
    </div>
  );
}
